<template>
	<b-modal ref="modal" title="Osveži podatke Trafic" class="modal-primary" ok-title="Zaključi" cancel-title="Prekliči" @ok="onOkModal" size="lg">
		<div v-show="showStep1" class="dUpload">
			<vue-dropzone ref="dzCdpTrafic" id="dropzoneCdpTrafic" class="dcImportCdpTrafic trafic" :include-styling="true" :options="usCdpTrafic" />
		</div>
		<div v-show="showStep2" class="dProcessing">
			Obdelava podatkov ...
			<b-progress :value="100" variant="success" striped :animated="animate" class="mb-2"></b-progress>
		</div>
		<div v-show="showStep3" v-html="uploadResultMessage"></div>
	</b-modal>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import service from '@/service';
import firebase from 'firebase';

const usDefaultValues = {
	url: process.env.API_BASE_URL + 'api/v1/cdp_vehicles_trafic_upload',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: true,
	maxFiles: 10,
	parallelUploads: 10,
	addRemoveLinks: false,
	paramName: 'trafic_import',
	// acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: function() {
		console.log('DZ init');
		let limitExceeded = false;
		this.on("addedfiles", function (files) {
			if (this.files.length > this.options.maxFiles) {
				if (!limitExceeded) {
					limitExceeded = true;
					this.removeAllFiles(true);
					alert(`Izberete lahko največ ${this.options.maxFiles} datotek. Izberite ponovno.`);
				}
			}
		});

		this.on("reset", function () {
			limitExceeded = false;
		});
	},
	uploadprogress: (file, progress, bytesSent, event) => {
		console.log('DZ uploadprogress');
		console.log(progress);
	},
};

export default {
	components: {
		vueDropzone: vue2Dropzone
	},
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.cdpTraficUploaded = null;
			this.$refs.dzCdpTrafic.removeAllFiles();
		},
		moveToProcessing: function () {
			if (this.cdpTraficUploaded) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				this.uploadResultMessage = '';
				service.cdpTraficImport(this.cdpTraficUploaded)
					.then(response => {
						this.uploadResultMessage += 'Trafic posodobljen. Najdenih je bilo <b>' + (response.data.found) + '</b>, od skupno <b>' + (response.data.total) + '</b> vnosov v pregednici.';
						this.showStep1 = false;
						this.showStep2 = false;
						this.showStep3 = true;
						this.$emit('data-updated');
					})
					.catch(error => {
						if (error) {
							console.log(error);
							this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
							this.showStep1 = false;
							this.showStep2 = false;
							this.showStep3 = true;
						}
					});
			}
		},
		dzTemplate: function () {
			return `<div class="dz-preview dz-file-preview">
				<div class="dz-image">
					<div data-dz-thumbnail-bg></div>
				</div>
				<div class="dz-details">
					<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)
				</div>
				<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
				<div class="dz-error-message"><span data-dz-errormessage></span></div>
				<div class="dz-success-mark"><i class="fa fa-check"></i></div>
				<div class="dz-error-mark"><i class="fa fa-close"></i></div>
			</div>`;
		}
	},
	data: function () {
		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			cdpTraficUploaded: null,
			usedVehiclesUploaded: null,
			dmvUploaded: null,
			uploadResultMessage: '',
			usCdpTrafic: {
				...usDefaultValues,
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteke <b>Trafic</b><br />',
				sending: (file, xhr, formData) => {
					console.log('DZ send');
				},
				error: (file, message, xhr) => {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					this.cdpTraficUploaded = null;
				},
				success: (file, response) => {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					this.cdpTraficUploaded = response.data.files;
					if (!this.showStep2) this.moveToProcessing();
				}
			}
		}
	},
	created () {
		let user = firebase.auth().currentUser;
		user.getIdToken().then((idToken) => {
			let headers = {
				'Authorization': 'Bearer ' + idToken
			};
			this.usCdpTrafic.headers = headers;
		});
	}
}
</script>

<style>
.dUpload {
	text-align: center;
	vertical-align: middle;
}
.dProcessing {
	min-height: 80px;
	border:2px solid #e5e5e5;
	letter-spacing:.2px;
	color: #555555;
	padding: 20px;
	box-sizing: border-box;
	transition: background-color .2s linear;
}
	.dProcessing:hover {
		background-color:#f6f6f6;
	}
.dcImportCdpTrafic {
	min-height: 40px;
	width: 80%;
	border:2px solid #e5e5e5;
	letter-spacing:.2px;
	color: #555555;
	padding: 5px;
	margin: 10px;
	box-sizing: border-box;
	transition: background-color .2s linear;
	display: inline-block;
	vertical-align: middle;
}
	.dcImportCdpTrafic:hover {
		background-color:#f6f6f6;
	}
	.dcImportCdpTrafic.trafic {
		background-color:#e1e4fc;
	}
.dcImportCdpTrafic.dz-clickable {
	cursor: pointer;
}
	.dcImportCdpTrafic .dz-message {
		text-align: center;
		margin: 1em 0;
	}
		.dcImportCdpTrafic.dz-started .dz-message {
			display: none;
		}
	.dcImportCdpTrafic .dz-preview {
		display: block;
		padding: 5px 0 5px 0;
	}
	.dcImportCdpTrafic .dz-preview .dz-image {
		display: none;
		background: none;
		width: 0;
		height: 0;
	}
	.dcImportCdpTrafic .dz-preview {
		display: block;
		position: relative;
		padding-bottom: 26px;
	}
	.dcImportCdpTrafic .dz-preview.dz-file-preview .dz-image {
		background: none;
	}
	.dcImportCdpTrafic .dz-preview .dz-details {
		background: none;
		color: #555555;
		font-size: 13px;
	}
		.dcImportCdpTrafic .dz-preview .dz-size {
			display: inline-block;
		}
		.dcImportCdpTrafic .dz-preview .dz-filename {
			display: inline-block;
		}

	.dcImportCdpTrafic .dz-preview .dz-progress {
		opacity: 1;
		z-index: 1000;
		pointer-events: none;
		height: 16px;
		width: 100%;
		background: rgba(133, 133, 133, 0.9);
		-webkit-transform: scale(1);
		border-radius: 8px;
		overflow: hidden;
		margin: 1px auto;
		position: absolute;
		bottom: 1px;
	}
	.dcImportCdpTrafic .dz-preview.dz-processing .dz-progress {
		opacity: 1;
		transition: all .2s linear;
	}
	.dcImportCdpTrafic .dz-preview.dz-complete .dz-progress {
		opacity: 0;
		transition: opacity .4s ease-in;
	}
	.dcImportCdpTrafic .dz-preview:not(.dz-processing) .dz-progress {
		animation: pulse 6s ease infinite;
	}
	.dcImportCdpTrafic .dz-preview .dz-progress .dz-upload {
		background: #333;
		background: linear-gradient(180deg,#666,#444);
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 0;
		transition: width .3s ease-in-out;
	}
	.dcImportCdpTrafic .dz-preview.dz-error .dz-error-message {
		display: block;
	}
	.dcImportCdpTrafic .dz-preview.dz-error:hover .dz-error-message {
		opacity: 1;
		pointer-events: auto;
	}
	.dcImportCdpTrafic .dz-preview .dz-error-message {
		pointer-events: none;
		z-index: 1000;
		display: none;
		opacity: 0.8;
		transition: opacity .3s ease;
		border-radius: 8px;
		font-size: 12px;
		height: 22px;
		line-height: 21px;
		width: 100%;
		background: #be2626;
		background: linear-gradient(180deg,#be2626,#a92222);
		color: #fff;
		text-align: center;
	}
	.dcImportCdpTrafic .dz-preview .dz-error-message:after {
		content: "";
		position: absolute;
		top: -6px;
		left: 64px;
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-bottom: 6px solid #be2626;
	}
	.dcImportCdpTrafic .dz-success-mark {
		position: absolute;
		bottom: 1px;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}
	.dcImportCdpTrafic .dz-error-message, .dcImportCdpTrafic .dz-success-mark, .dcImportCdpTrafic .dz-error-mark, .dcImportCdpTrafic .dz-remove {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/ImportCdpTraficModal.vue